import { render, staticRenderFns } from "./PromptPopup.vue?vue&type=template&id=4070a22d&"
import script from "./PromptPopup.vue?vue&type=script&lang=js&"
export * from "./PromptPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports